/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import VacancyOverview from './components/VacancyOverview';

/* utilities */
import { parseDataToProps } from '~/utilities';

const VacancyOverviewNodes = Array.from(document.querySelectorAll('.vacancy-overview'));
[...VacancyOverviewNodes].forEach((node) => render(<VacancyOverview {...parseDataToProps(node.dataset)} />, node));
